import { ref } from "vue";

export function useFullScreen() {
  const isFullscreen = ref(false);
  const playerID = ref('');

  /**
   * `id` is the qx-player `uniqId` of the requesting player. Omitting it marks an app-driven toggle
   * (the Timeline's own controls) rather than one a player owns; surfaces depend on that distinction.
   *
   * 1. Entering is idempotent — a second `toggle(true)`, whether from a remount or another player,
   *    hands ownership over rather than dropping the app back out of fullscreen.
   * 2. Only the owning player may exit, so an unrelated player unmounting cannot tear down
   *    fullscreen that another is still using.
   */
  const toggle = (val: boolean, id?: string) => {
    const html = document.getElementsByTagName('html')[0];

    if (val) {
      isFullscreen.value = true;
      html.classList.add('fullscreen');
      if (!!id && playerID.value != id) {
        playerID.value = id;
      }
      return;
    }

    if (!!id && !!playerID.value && playerID.value != id) {
      return;
    }

    isFullscreen.value = false;
    html.classList.remove('fullscreen');
    playerID.value = '';
  };

  return {
    isFullscreen,
    playerID,
    toggle
  }
}
